import { HtmlRenderMode } from "@commonRendering/types";
import { IAutoplayData } from "@pageBuilder/typings";

export class SliderAutoplayRenderer {

    public render(sectionElement: HTMLElement, data: IAutoplayData, renderingMode: HtmlRenderMode): void {
        if (data.enable) {
            sectionElement.setAttribute("data-autoplay-enable", "");

            if (renderingMode === "editor"){
                sectionElement.setAttribute("data-edit-mode", "");
            }

            if (data.timeBetweenSlidesSec) {
                sectionElement.setAttribute("data-time-between-slides", data.timeBetweenSlidesSec.toString());
            }
        } else {
            this.cleanup(sectionElement);
        }
    }

    public cleanup(sectionElement: HTMLElement): void {
        sectionElement.removeAttribute("data-autoplay-enable");
        sectionElement.removeAttribute("data-time-between-slides");
    }

}
